import React, { useState } from "react";
import BrochureForm from "../components/EnquiryForm"; // The pop-up form
import './SeatDistribution.css'; // Make sure this path points to your new file
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import CTAButtons from "../components/sticky-button";
import PageHeader from "../about/PageHeader";
import ContactAdmissionsStrip from '../components/ContactAdmissionsStrip';

const SeatAllocation = () => {
const [showForm, setShowForm] = useState(false);
  return (
    <>
      <Navbar />
      <CTAButtons />

      <PageHeader
        title="Seat Distribution"
        crumbs={[{ label: 'Home', href: '/' }, { label: 'Seat Distribution' }]}
      />
      {showForm && <BrochureForm setShowForm={setShowForm} />}
      <div className="tda-container-wrapper">
        <div className="tda-main-card">
          
          {/* Header Bar */}
          <div className="tda-card-header">
            <h3 className="tda-card-title">
              <span className="tda-title-icon-box">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line></svg>
              </span>
              Allocation of Seats Within Sanctioned Intake
            </h3>
            <button className="tda-download-btn" onClick={() => window.print()}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{marginRight: '6px'}}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
              Download Seat Matrix
            </button>
          </div>

          {/* Table Container */}
          <div className="tda-table-scroll">
            <table className="tda-responsive-table">
              <thead>
                <tr>
                  <th rowSpan="2" style={{ textAlign: 'left', width: '30%' }}>PROGRAM</th>
                  <th rowSpan="2" style={{ textAlign: 'center', width: '18%' }}>SANCTIONED INTAKE</th>
                  <th style={{ textAlign: 'center', width: '18%' }}>CAP QUOTA</th>
                  <th style={{ textAlign: 'center', width: '18%' }}>MINORITY QUOTA</th>
                  <th style={{ textAlign: 'center', width: '16%' }}>INSTITUTE LEVEL SEATS</th>
                </tr>
                <tr>
                  <th className="tda-sub-th">SEATS WILL BE FILLED UP THROUGH CAP ONLY (CENTRALIZED ADMISSION PROCESS)</th>
                  <th className="tda-sub-th">SEATS WILL BE FILLED UP THROUGH CAP ONLY (CENTRALIZED ADMISSION PROCESS)</th>
                  <th className="tda-sub-th">SEATS WILL BE FILLED UP INSTITUTE ONLY</th>
                </tr>
              </thead>
          {/* Replace your <tbody> section with this marked-up version */}
        <tbody>
          <tr className="tda-percentage-row">
            <td data-label="PROGRAM" style={{ textAlign: 'left' }}>No. of Seats as % of Section Intake</td>
            <td data-label="SANCTIONED INTAKE" style={{ textAlign: 'center' }}>100%</td>
            <td data-label="CAP QUOTA" style={{ textAlign: 'center' }}><span className="tda-badge-cap">29%</span></td>
            <td data-label="MINORITY QUOTA" style={{ textAlign: 'center' }}><span className="tda-badge-minority">51%</span></td>
            <td data-label="INSTITUTE LEVEL SEATS" style={{ textAlign: 'center' }}><span className="tda-badge-institute">20%</span></td>
          </tr>
          <tr className="tda-data-row mca-row">
            <td data-label="PROGRAM" style={{ textAlign: 'left' }}>MCA</td>
            <td data-label="SANCTIONED INTAKE" style={{ textAlign: 'center' }}>300</td>
            <td data-label="CAP QUOTA" style={{ textAlign: 'center' }}>87</td>
            <td data-label="MINORITY QUOTA" style={{ textAlign: 'center' }}>153</td>
            <td data-label="INSTITUTE LEVEL SEATS" style={{ textAlign: 'center' }}>60</td>
          </tr>
          <tr className="tda-data-row">
            <td data-label="PROGRAM" style={{ textAlign: 'left' }}>MCA (Integrated)</td>
            <td data-label="SANCTIONED INTAKE" style={{ textAlign: 'center' }}>60</td>
            <td data-label="CAP QUOTA" style={{ textAlign: 'center' }}>17</td>
            <td data-label="MINORITY QUOTA" style={{ textAlign: 'center' }}>31</td>
            <td data-label="INSTITUTE LEVEL SEATS" style={{ textAlign: 'center' }}>12</td>
          </tr>
          <tr className="tda-data-row">
            <td data-label="PROGRAM" style={{ textAlign: 'left' }}>MCA (Working Professional)</td>
            <td data-label="SANCTIONED INTAKE" style={{ textAlign: 'center' }}>60</td>
            <td data-label="CAP QUOTA" style={{ textAlign: 'center' }}>17</td>
            <td data-label="MINORITY QUOTA" style={{ textAlign: 'center' }}>31</td>
            <td data-label="INSTITUTE LEVEL SEATS" style={{ textAlign: 'center' }}>12</td>
          </tr>
        </tbody>
            </table>
          </div>

  {/* Important Notes Box */}
          <div className="tda-notes-card">
            <div className="tda-notes-header">
              <span className="tda-notes-icon">i</span>
              <h4 className="tda-notes-title">Important Notes</h4>
            </div>
            <ul className="tda-notes-list">
              <li>
                TIMSCDR-A Centre of Excellence for candidate aspiring for Quality Technical Education and rewarding career. As per DTE/CET Cell notification, the admission process for 51% Hindi Linguistic Minority Quota and 29% CAP Quota will be carried out by DTE thorough multiple admission rounds. Candidate aspiring admission to TIMSCDR can give first option or can freeze the admission. Moreover, they also have option for admission during the vacancy subject to availability of seats.
              </li>
              <li>
                Institute level Seats is 20% of the Sanctioned Intake. For Admission enquiries contact at Reception in Administrative Office.
              </li>
            </ul>
            
            {/* Custom SVG matching the reference document icon */}
            <div className="tda-notes-watermark">
              <svg width="85" height="105" viewBox="0 0 70 85" fill="none" xmlns="http://www.w3.org/2000/svg">
                {/* Document Base */}
                <path d="M5 5 C5 2.23858 7.23858 0 10 0 L45 0 L65 20 L65 75 C65 77.7614 62.7614 80 60 80 L10 80 C7.23858 80 5 77.7614 5 75 L5 5 Z" fill="#f0effa"/>
                {/* Folded Corner */}
                <path d="M45 0 L65 20 L45 20 L45 0 Z" fill="#e1e0f4"/>
                {/* Text Lines */}
                <rect x="15" y="28" width="25" height="4" rx="2" fill="#d2cff0"/>
                <rect x="15" y="38" width="35" height="4" rx="2" fill="#d2cff0"/>
                <rect x="15" y="48" width="40" height="4" rx="2" fill="#d2cff0"/>
                <rect x="15" y="58" width="20" height="4" rx="2" fill="#d2cff0"/>
                {/* Blue Info Badge */}
                <circle cx="55" cy="65" r="12" fill="#7571e1"/>
                <text x="55" y="70" fill="white" fontSize="13" fontWeight="bold" fontFamily="-apple-system, BlinkMacSystemFont, sans-serif" textAnchor="middle">i</text>
              </svg>
            </div>
          </div>

        </div>
      </div>
       <ContactAdmissionsStrip onAppointmentClick={() => setShowForm(true)} />
      <Footer />

    </>
  );
};

export default SeatAllocation;